import { type PdfCell, createPdfTableBlob } from './pdf-common';
import { type ExportHeaderInfo, type PortAssignmentExportData } from './types';

export const buildPortAssignmentsPdfBlob = (
  data: PortAssignmentExportData[],
  filename: string,
  headerInfo?: ExportHeaderInfo,
): { blob: Blob; filename: string } => {
  const head = [
    'Name',
    'Target',
    'Target Port',
    'Source',
    'Source Port',
    'VLAN IDs',
    'PoE',
    'DHCP',
  ];
  const body: PdfCell[][] = data.map((p) => [
    p.Name,
    p.Target,
    p['Target Port'],
    p.Source,
    p['Source Port'],
    p.vlanIdsFormatted,
    p.poe,
    p.dhcp,
  ]);
  return createPdfTableBlob(head, body, filename, headerInfo);
};
